import { Splide } from '../vendors/splide.esm';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;

class Carousel {
    constructor(id, config) {
        this.el = document.getElementById(id);
        this.config = config;
        this.carousel = null;
        this.state = true;
        this.statesp = true;
        this.init();
    }

    init() {
        if (this.el) {
            const _this = this;
            this.carousel = new Splide(this.el, this.config);
            let barEl = this.carousel.root.querySelector('.jsProgressBar');
            this.carousel.on('mounted move', function () {
                const end = _this.carousel.Components.Controller.getEnd() + 1;
                const rate = Math.min((_this.carousel.index + 1) / end, 1);
                if (barEl) {
                    barEl.style.width = String(100 * rate) + '%';
                }
            });
            this.carousel.mount();
        }
    }
}

function renderSlide(el) {
    const mobileW = 768,
        slideConfig = {
            drag: false,
            destroy: true,
            breakpoints: {
                768: {
                    pagination: false,
                    arrows: false,
                    speed: 1000,
                    perMove: 1,
                    drag: true,
                    autoWidth: true,
                    destroy: false,
                    type: el.dataset.state === 'scroll' ? 'slide' : 'loop',
                    focus: el.dataset.state === 'center' ? el.dataset.state : '',
                    gap: '20px'
                },
            }
        };
    if (window.innerWidth <= mobileW) {
        let slideEls = el.querySelectorAll('.splide__slide ')
        if (slideEls.length > 0) {
            let btnEl = slideEls[slideEls.length - 1].querySelector('.e-btn--1');
            if (btnEl) {
                el.appendChild(btnEl.cloneNode(true));
                slideEls[slideEls.length - 1].remove();
                new Carousel(el.id, slideConfig);
            }else {
                new Carousel(el.id, slideConfig);
            }
        }
    } else {
        let checkEls = el.querySelectorAll('.splide__slide .e-btn--1');
        if (checkEls.length === 0) {
            let btnEl = el.querySelector('.e-btn--1');
            if (btnEl) {
                let slideEl = window.createTag('div', { className: 'splide__slide' });
                slideEl.appendChild(btnEl.cloneNode(true));
                el.querySelector('.splide__list').appendChild(slideEl);
                btnEl.remove();
            }
        }
    }
}

function initCarousel(el) {
    renderSlide(el);
    window.addEventListener('resize', () => {
        renderSlide(el);
    });
}
$(window).on('load', function () {
    updateJsInfoUserTop(1);

    $(document).on('click', '.jsClickUserTop', async function (e) {
        e.preventDefault();
        let gcode = $(this).data('gcode');
        const btnEl = document.querySelector('#jsCarouselUserTop .e-btn--1');
        if(btnEl) {
            btnEl.remove();
        }
        updateJsInfoUserTop(gcode);
    });

    function updateJsInfoUserTop(gcode)
    {
        $.ajax({
            url: '/ajax/top-genre',
            type: 'get',
            dataType: 'json',
            data: { gcode: gcode },
        }).done(function (data) {
            const container = document.querySelector('.jsInfoUserTop');
            if (container) {
                container.innerHTML = data.html;
                let carouselUserEl = document.getElementById('jsCarouselUserTop');
                if (carouselUserEl) {
                    initCarousel(carouselUserEl);
                }
            }
        }).fail(function (error) {
            console.error('AJAX error:', error);
        });
    }

});

$(function () {
    const $form = $('#formSearch');

    if (!$form.length) {
        return;
    }

    function getGenreValues() {
        let genreBValue = '', genreSValue = '';
        const formEl = document.getElementById('formSearch');

        if (formEl && window.innerWidth > 768) {
            formEl.querySelectorAll('[name="genreB"]').forEach((el) => {
                if (el.type === 'radio' && el.checked) {
                    genreBValue = el.value;
                }
            });

            formEl.querySelectorAll('[name="genreS"]').forEach((el) => {
                if (el.type === 'radio' && el.checked) {
                    genreSValue = el.value;
                }
            });
        } else {
            genreBValue = $('#genreB_id').val();
            genreSValue = $('#genreS_id').val();
        }

        return {
            genreBValue: genreBValue && genreBValue !== '-1' ? genreBValue : '',
            genreSValue: genreSValue && genreSValue !== '-1' ? genreSValue : '',
        };
    }

    const $keywordInput = $('#lecturer');
    const delay = 300;
    const keywordDelay = 600;
    let debounceTimer = null;
    let currentXhr = null;
    let lastRequestKey = null;
    let isComposing = false;

    $form
        .on('input', 'input:not([type=radio]):not([type=checkbox]), textarea', function (event) {
            if (event.target.id === 'lecturer' && isComposing) {
                return;
            }

            scheduleDebounce(event);
        })
        .on('change', 'select, input[type=radio], input[type=checkbox]', scheduleDebounce)
        .on('submit', function (e) {
            e.preventDefault();
            const formData = new FormData($form[0]);
            const params = new URLSearchParams();
            const { genreBValue, genreSValue } = getGenreValues();

            for (const [name, val] of formData.entries()) {
                if (name === 'genreB' || name === 'genreS') {
                    continue;
                }

                if (val) {
                    params.set(name, val);
                }
            }

            // If both genreB and genreS are selected, only pass genreS
            if (genreSValue) {
                params.set('genreS', genreSValue);
            } else if (genreBValue) {
                params.set('genreB', genreBValue);
            }

            window.location.href = $form.attr('action') + '?' + params.toString();
        });

    $keywordInput
        .on('compositionstart', function () {
            isComposing = true;
            clearTimeout(debounceTimer);
        })
        .on('compositionend', function (event) {
            isComposing = false;
            scheduleDebounce(event);
        })
        .on('blur', function (event) {
            window.setTimeout(() => {
                isComposing = false;
                scheduleDebounce(event);
            }, 0);
        });

    function scheduleDebounce(event) {
        clearTimeout(debounceTimer);

        const debounceDelay = event?.target?.id === 'lecturer' ? keywordDelay : delay;
        debounceTimer = window.setTimeout(performDebounce, debounceDelay);
    }

    function performDebounce() {
        const { genreBValue, genreSValue } = getGenreValues();
        const params = new URLSearchParams($form.serialize());

        params.delete('genreB');
        params.delete('genreS');

        if (genreBValue) params.set('genreB', genreBValue);
        if (genreSValue) params.set('genreS', genreSValue);

        const keyword = params.get('keyword')?.trim() ?? '';
        if (keyword) {
            params.set('keyword', keyword);
        } else {
            params.delete('keyword');
        }

        if (!hasValidValue()) {
            lastRequestKey = null;
            $('#countSearch').text('0人');
            return;
        }

        const requestKey = params.toString();
        if (requestKey === lastRequestKey) {
            return;
        }

        lastRequestKey = requestKey;

        if (currentXhr && typeof currentXhr.abort === 'function') {
            currentXhr.abort();
            currentXhr = null;
        }

        currentXhr = $.ajax({
            url: '/ajax/search/count',
            type: 'get',
            dataType: 'json',
            data: params.toString(),
            success: function (res) {
                const count = res.count ?? 0;
                $('#countSearch').text(`${count}人`);
            },
            complete: function () {
                currentXhr = null;
            }
        });

    }

    function hasValidValue() {
        let valid = false;

        $form.find('input, select, textarea').each(function () {
            let val = $(this).val();

            if ((this.type === 'radio' || this.type === 'checkbox') && !this.checked) {
                return;
            }

            if (val === null || val === '') {
                return;
            }

            if (val == -1) {
                return;
            }

            valid = true;
            return false;
        });

        return valid;
    }
});